import { Pipe, PipeTransform } from '@angular/core';

import { itensFormulariosIndicadores } from '../item-formulario';

@Pipe({
    name: 'configCotacaoItemFormularioPipe'
})
export class ConfigCotacaoItemFormularioIndicadorPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = itensFormulariosIndicadores.findIndex(indicador => indicador.id === value);
        if (index > -1) {
            return itensFormulariosIndicadores[index].nome;
        }
        return '';
    }
}
